import { gql } from '@apollo/client/core'

/**
 * GraphQL query for fetching all sections
 * Replaces /all-sections.json endpoint
 * 
 * Note: Entry-type-specific fields (custom fields) must be accessed via fragments.
 * The entry type handle format is typically {sectionHandle}_Entry (e.g., sections_Entry).
 */
export const GET_ALL_SECTIONS = gql`
  query GetAllSections {
    entries(section: "sectionHouse", orderBy: "sort", status: ["enabled", "disabled", "pending"]) {
      id
      title
      url
      enabled
      status
      postDate
      __typename
      ... on sectionEmpty_Entry {
        price
        sectionSize
        sectionStatus
        sectionType
        screenshot {
          id
        }
        stage {
          id
          title
        }
      }
      ... on townhouse_Entry {
        price
        sectionSize
        sectionStatus
        sectionType
        superlotType
        screenshot {
          id
        }
        stage {
          id
          title
        }
      }
      ... on houseLand_Entry {
        price
        hasTitle
        sectionSize
        floorSize
        livingRooms
        bedrooms
        bathrooms
        toilets
        cars
        sectionStatus
        sectionType
        screenshot {
          id
        }
        stage {
          id
          title
        }
        imagesSection {
          url(width: 900, height: 400, mode: "crop", format: "webp", quality: 82)
          title
          alt
        }
      }
      ... on showHome_Entry {
        price
        sectionSize
        floorSize
        livingRooms
        bedrooms
        bathrooms
        toilets
        cars
        sectionStatus
        screenshot {
          id
        }
        stage {
          id
          title
        }
        imagesSection {
          url(width: 900, height: 400, mode: "crop", format: "webp", quality: 82)
          title
          alt
        }
      }
    }
  }
`

/**
 * GraphQL query for fetching all stages
 * Replaces /all-stages.json endpoint
 * 
 * Note: Entry-type-specific fields (custom fields) must be accessed via fragments.
 * The entry type handle format is typically {sectionHandle}_Entry (e.g., stages_Entry).
 */
export const GET_ALL_STAGES = gql`
  query GetAllStages {
    entries(section: "stages") {
      id
      title
      ... on stages_Entry {
        titles
        stageStatus
      }
    }
  }
`

/**
 * GraphQL query for fetching the current map SVG
 * Gets the top-most entry from the Maps structure section
 * 
 * Note: Uses lft (left) ordering to get the first entry in the structure.
 * Only enabled entries are returned by default.
 */
export const GET_CURRENT_MAP = gql`
  query GetCurrentMap {
    entries(section: "maps", limit: 1, orderBy: "lft ASC") {
      id
      title
      ... on maps_Entry {
        svgFile {
          url
        }
      }
    }
  }
`

export const GET_ALL_MAPS = gql`
  query GetAllMaps {
    entries(section: "maps", orderBy: "lft ASC", status: ["enabled", "disabled", "pending"]) {
      id
      title
      enabled
      status
      postDate,
      ... on maps_Entry {
        svgFile {
          url
        }
      }
    }
  }
`